<div class="pagination-controls">
  <label [for]="selectId">Show</label>
  <select
    [id]="selectId"
    class="page-size"
    [(ngModel)]="pageSize"
    (change)="onPageSizeChange($event)"
    aria-label="Select number of results per page"
  >
    @for (option of pageSizeOptions; track option) {
      <option [value]="option">{{ option }}</option>
    }
  </select>
  <span>results</span>
</div>
